/**
 * `utils/dom.js`
 *  - DOM操作
 *
 * 役割:
 *  - クラスの付け替えなど
 *
 * 使用方法:
 *  - import {getContainer, toggleClass, addClass, removeClass} from "utils/index.js";
 *    or
 *  - import {getContainer, toggleClass, addClass, removeClass} from "utils/dom.js";
 *
 * 関連ファイル
 *  - `utils/index.js`
 */


/**
 * `barba.js` の有効/無効に関係なく要素を取得する関数
 *
 * @param {object} [data] - `barba.js` の `data` オブジェクト (省略可)
 * @returns {Element|NodeList|null} - 取得した要素（単数 or 複数）
 */
export const getContainer = (data = null) => {
  return data?.next?.container || document;
};


/**
 * `barba.js` の有効/無効に関係なくnamespaceを取得する関数
 *
 * @param {object} [data] - `barba.js` の `data` オブジェクト (省略可)
 * @return {string} - 取得したnamespace
 */
export const getNamespace = (data = null) => {
  return data?.next?.namespace || document.querySelector("main")?.dataset?.transNamespace || "home";
}

/**
 * クラスのトグル
 */
export function toggleClass(element, className) {
  element.classList.toggle(className);
}

/**
 * クラスを追加
 */
export function addClass(element, className) {
  element.classList.add(className);
}

/**
 * クラスを削除
 */
export function removeClass(element, className) {
  element.classList.remove(className);
}